import { render, staticRenderFns } from "./OverviewNote.vue?vue&type=template&id=61a791b8&scoped=true&lang=pug&"
import script from "./OverviewNote.vue?vue&type=script&lang=js&"
export * from "./OverviewNote.vue?vue&type=script&lang=js&"
import style0 from "./OverviewNote.vue?vue&type=style&index=0&id=61a791b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a791b8",
  null
  
)

export default component.exports